// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"3e9b8f20","861":"3bc1770d"}[chunkId] + ".chunk.js";
};